import React from 'react';
import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';
import * as IoIcons from 'react-icons/io';

export const SidebarDataS = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    icon: "	fas fa-desktop",
    cName: 'nav-text'
  },
  
  {
    title: 'Register',
    path: '/ApproveAcc',
    icon: "	fas fa-chalkboard-teacher",
    cName: 'nav-text'
  },
  {
    title: 'TM Details',
    path: '/TMDetails',
    icon: "fas fa-edit",
    cName: 'nav-text'
  },
  {
    title: 'Add Post',
    path: '/AddPost',
    icon: "fas fa-laptop-code",
    cName: 'nav-text'
  },

  {
    title: 'User base',
    path: '/UserApprove',
    icon: "	fas fa-user-cog",
    cName: 'nav-text'
  },

  {
    title: 'user Locations',
    path: '/userLocations',
    icon: "	fas fa-child",
    cName: 'nav-text'
  },



];
